import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Checkbox, FormField } from "ui";

import { VideoFormAtomProps } from "../VideoForm.types";

import styles from "../VideoForm.module.scss";

const TutorialFlagsField = ({ control }: VideoFormAtomProps) => {
  const { t } = useTranslation();

  return (
    <FormField label={"Used as a tutorial"}>
      <div className={styles.form_userTypeOptions}>
        <Controller
          control={control}
          name="isOrderTutorial"
          render={({ field: { value, onChange } }) => (
            <Checkbox
              label={t("WhatsApp chat")}
              checked={!!value}
              onChange={(event) => onChange(event.target.checked)}
            />
          )}
        />

        <Controller
          control={control}
          name="isWebviewTutorial"
          render={({ field: { value, onChange } }) => (
            <Checkbox
              label={t("Web page")}
              checked={!!value}
              onChange={(event) => onChange(event.target.checked)}
            />
          )}
        />
      </div>
    </FormField>
  );
};

export default TutorialFlagsField;
